import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startLTIOrgKeyManagement = () => {
  const root = createRoot(document.getElementById('ltiOrgKeyManagementApp'))
  root.render(<App />)
}
